"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfStartOvertimePreviewDto = instanceOfStartOvertimePreviewDto;
exports.StartOvertimePreviewDtoFromJSON = StartOvertimePreviewDtoFromJSON;
exports.StartOvertimePreviewDtoFromJSONTyped = StartOvertimePreviewDtoFromJSONTyped;
exports.StartOvertimePreviewDtoToJSON = StartOvertimePreviewDtoToJSON;
exports.StartOvertimePreviewDtoToJSONTyped = StartOvertimePreviewDtoToJSONTyped;
/**
 * Check if a given object implements the StartOvertimePreviewDto interface.
 */
function instanceOfStartOvertimePreviewDto(value) {
    if (!('payPeriodStart' in value) || value['payPeriodStart'] === undefined)
        return false;
    if (!('payPeriodEnd' in value) || value['payPeriodEnd'] === undefined)
        return false;
    return true;
}
function StartOvertimePreviewDtoFromJSON(json) {
    return StartOvertimePreviewDtoFromJSONTyped(json, false);
}
function StartOvertimePreviewDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'payPeriodStart': json['payPeriodStart'],
        'payPeriodEnd': json['payPeriodEnd'],
        'zealEmployeeCheckId': json['zealEmployeeCheckId'] == null ? undefined : json['zealEmployeeCheckId'],
    };
}
function StartOvertimePreviewDtoToJSON(json) {
    return StartOvertimePreviewDtoToJSONTyped(json, false);
}
function StartOvertimePreviewDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'payPeriodStart': value['payPeriodStart'],
        'payPeriodEnd': value['payPeriodEnd'],
        'zealEmployeeCheckId': value['zealEmployeeCheckId'],
    };
}
//# sourceMappingURL=StartOvertimePreviewDto.js.map